import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers';
import { SearchManagerOutput } from '@/hooks/search/useSearch';
import { _t } from '@/locale';
import { Fragment } from 'react/jsx-runtime';
import { baseTranslationKey } from '../pages';

export const MatchingSearchResultsCount = ({ type, results, loading }: SearchManagerOutput & { loading: boolean }) => {
  /**
   * show mirrored skeleton when loading to avoid layout shift
   */
  if (loading) {
    const gradientBase = 'bg-surface_l3 animate-pulse';
    return (
      <div className="space-x-sm flex w-full items-center" role="status" aria-live="polite">
        <div
          aria-hidden="true"
          className={classnames(gradientBase, 'h-xl w-xl rounded')}
          style={{ height: 24, width: 24 /** hight and width of icon */ }}
        />
        <div
          aria-hidden="true"
          className={classnames(gradientBase, 'rounded')}
          style={{ width: 200, height: 18 /** height of text-m */ }}
        />
        <span className="sr-only">{_t(`${baseTranslationKey}.loadingSearchResults`)}</span>
      </div>
    );
  }

  if (results < 1) {
    return null;
  }

  const isSistaminutenSearch = type === 'sistaminuten';
  return (
    <Fragment>
      <Icon variant="search-check" color="fg_secondary" size="sm" style={{ width: 24, height: 24 }} />
      <span className="text-fg_secondary text-m">
        {_t(`${baseTranslationKey}.hits${isSistaminutenSearch ? 'WithDiscount' : ''}`, {
          hits: results,
        })}
      </span>
    </Fragment>
  );
};
